var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ active: _vm.active_menu },attrs:{"id":"burger"},on:{"click":_vm.toggleMenu}},[_c('span'),_c('span'),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }